import { Producer } from 'types/producer'

export type ProducersOverviewProps = {
  producers: Producer[]
}

export enum MobileView {
  MAP = 'Map',
  LIST = 'List'
}
